import './polyfills';
import { Manifest } from './configuration/Manifest';
import { loadExternalScripts } from './utils/scripts';
import { defineEventBusComponent } from './ksys-event-bus';
import { TemplateStore } from './stores/TemplateStore';

export const TEMPLATE_STORE = new TemplateStore();

async function initialize() {
    defineEventBusComponent();
    await TEMPLATE_STORE.initialize();
    loadExternalScripts(
        Manifest.externalScripts,
        () => {
            require('./start');
        },
        TEMPLATE_STORE.externalScriptsBasePath || Manifest.getBaseUrl(''),
        TEMPLATE_STORE.cacheOptions
    );
}

initialize();



// WEBPACK FOOTER //
// ./src/index.tsx